import React from "react";
import { connect } from "react-redux";
import { snackbarHide } from "./actions";
import Snackbar from "material-ui/Snackbar";

const MySnackbar = props => {
  const { dispatch, ...rest } = props;
  return (
    <Snackbar
      {...rest}
      bodyStyle={{
        height: "auto",
        lineHeight: "28px",
        padding: 24,
        whiteSpace: "pre-line"
      }}
    />
  );
};

const mapStateToProps = state => ({
  open: state.app.snackbar.open,
  message: state.app.snackbar.message
});

const mapDispatchToProps = dispatch => ({
  onRequestClose: () => {
    dispatch(snackbarHide());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MySnackbar);



// WEBPACK FOOTER //
// ./src/app/Snackbar.js